"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  maxWidth: 600,
  margin: 'auto',
  overflow: 'hidden',
  WebkitLineClamp: 6,
  WebkitBoxOrient: 'vertical',
  [theme.breakpoints.up('sm')]: {
    WebkitLineClamp: 4
  }
}));
